import { LoggedInUser } from "../state/reducers/UserReducer";

export function getSiteForLoggedInUser(loggedInUser: LoggedInUser | null){
  if(!loggedInUser) return undefined;
  if(loggedInUser.territory === 'au') return 1;
  if(loggedInUser.territory === 'nz') return 2;
}